export default __webpack_public_path__ + "maps-examples-restrict-coordinate-bounds-thumbnail-480-b249d5b0e9dda91fe66c97ad7e35e783.webp";